import { render, staticRenderFns } from "./GatewayHealth.global.vue?vue&type=template&id=5fdbea89&scoped=true&lang=pug&"
import script from "./GatewayHealth.global.vue?vue&type=script&lang=ts&"
export * from "./GatewayHealth.global.vue?vue&type=script&lang=ts&"
import style0 from "./GatewayHealth.global.vue?vue&type=style&index=0&id=5fdbea89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdbea89",
  null
  
)

export default component.exports